import { render } from "./EconomicIndicatorForm.vue?vue&type=template&id=29ced609"
import script from "./EconomicIndicatorForm.vue?vue&type=script&lang=js"
export * from "./EconomicIndicatorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__